import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AddressResponse, LocationPayload, UpdateLocationPayload } from "../components/list-addresses/interfaces/addresses-user.interface";
import { Observable } from "rxjs";
import { environment } from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})

export class AddNewAddressService {
  constructor(private http: HttpClient) {

  }


  saveAddress(locationData: LocationPayload): Observable<AddressResponse> {
    return this.http.post<AddressResponse>(`${environment.apiUrl}/address/add`, locationData);
  }
  updateAddress(locationData: UpdateLocationPayload): Observable<AddressResponse> {
    return this.http.post<AddressResponse>(`${environment.apiUrl}/address/update`, locationData);
  }
}


